export default class ManageExperimentsForm {
	constructor(app){
		this.app = app;
		this.reset();
	}

	reset(){
		this.statusFilter = '';
		this.sortAscending = true;
		this.rows = [];
		this.loading = false;
	}

	async load(){
		this.app.startLoadingForm(this);
		try{
			const rows = await this.app.http.getResearcherExperiments();
			const formattedRows = rows.map(row => {
				if(!this.app.statusMap[row.status]){ row.status = 'inactive'; }
				row.incentive = +row.incentive || 0;
				row.time = +row.time || 0;
				row.participants = +row.participants || 0;
				return {
					...this.app.EXPERIMENT_DEFAULTS,
					...row
				};
			});

			this.rows = formattedRows;
			this.app.stopLoadingForm(this);
		}catch(e){
			this.app.stopLoadingForm(this, e);
		}
	}
}












// WEBPACK FOOTER //
// ./src/models/ManageExperimentsForm.js